import { makeStyles } from '@material-ui/core';
import logo from '../../assets/logo-kovi-branco.svg';

const useStyles = makeStyles({
  img: {
    width: 'auto',
    height: 28,
  },
});

export const LogoFull = () => {
  const classes = useStyles();
  return <img src={logo} alt="Kovi" className={classes.img} />;
};
